var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.424 3.92L13.6681 9.5C13.4084 9.88 13.9079 10.34 14.2675 10.02L17.9634 6.8C18.0633 6.72 18.2031 6.78 18.2031 6.92V16.98C18.2031 17.12 18.0233 17.18 17.9434 17.08L6.75583 3.68C6.39623 3.24 5.8768 3 5.29745 3H4.89789C3.85905 3 3 3.86 3 4.92V19.08C3 20.14 3.85905 21 4.91787 21C5.57714 21 6.19645 20.66 6.55605 20.08L10.3119 14.5C10.5716 14.12 10.0721 13.66 9.71254 13.98L6.01665 17.18C5.91676 17.26 5.77691 17.2 5.77691 17.06V7.02C5.77691 6.88 5.95671 6.82 6.03663 6.92L17.2242 20.32C17.5838 20.76 18.1232 21 18.6826 21H19.0821C20.141 21 21 20.14 21 19.08V4.92C20.98 3.86 20.121 3 19.0622 3C18.4029 3 17.7836 3.34 17.424 3.92Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNear);
export default __webpack_public_path__ + "static/media/near.e0ea39c15a41503970a0c01fb578bc2a.svg";
export { ForwardRef as ReactComponent };